/**
 * Deep-link handling.
 *
 * When a policyholder emails a claim packet from the app, the recipient gets
 * a URL like `https://claimscope.app/share/timeline/<token>.pdf`. If that
 * recipient happens to have the ClaimScope app installed, we want the
 * system to hand the URL off to the app rather than Safari/Chrome.
 */
import { App } from "@capacitor/app";
import { isNative } from "./platform";

export function registerDeepLinkListener(navigate) {
  if (!isNative()) return () => {};
  const subscription = App.addListener("appUrlOpen", (event) => {
    try {
      const url = new URL(event.url);
      const path = url.pathname + url.search;
      if (path && path !== "/") navigate(path);
    } catch {
      // malformed URL — silent; system will show its default error UI
    }
  });
  return () => {
    Promise.resolve(subscription).then((handle) => handle.remove?.());
  };
}
